import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgInjuryLegsling = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11.7676 8.63501L15.9501 12.3442"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.2476 7.23834L19.4301 10.9475"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.4225 4.21667L16.97 8.76584"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9416 13.9533L20.5899 10.4825C20.7423 10.4214 20.8812 10.3309 20.9986 10.2161C21.1161 10.1013 21.2097 9.96456 21.2743 9.81357C21.3388 9.66259 21.373 9.50037 21.3748 9.33619C21.3766 9.172 21.3461 9.00906 21.2849 8.85667L19.4224 4.21667C19.3033 3.90769 19.124 3.62545 18.8948 3.38635C18.6657 3.14725 18.3914 2.95605 18.0878 2.82386C17.7841 2.69167 17.4573 2.62112 17.1261 2.61631C16.795 2.6115 16.4662 2.67252 16.1589 2.79583C15.8515 2.91914 15.5718 3.10229 15.3358 3.33463C15.0998 3.56697 14.9124 3.84388 14.7843 4.14927C14.6562 4.45467 14.5901 4.78246 14.5898 5.11362C14.5895 5.44478 14.655 5.7727 14.7824 6.07834L15.2499 7.23834L11.6799 8.67167"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.625 17.625L7.72 15.215"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.9025 10.6133L2.625 12"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.375 2.625L11.9583 14.2567C11.9709 14.5115 11.9053 14.7641 11.7702 14.9806C11.6351 15.197 11.437 15.3669 11.2025 15.4675L9.45246 16.2175C9.25812 16.3007 9.04584 16.3333 8.83549 16.3121C8.62514 16.291 8.42359 16.2169 8.24968 16.0967C8.07577 15.9764 7.9352 15.8141 7.8411 15.6248C7.747 15.4355 7.70245 15.2254 7.71163 15.0142L8.24996 2.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.625 21.375H20.125C20.4565 21.375 20.7745 21.2433 21.0089 21.0089C21.2433 20.7745 21.375 20.4565 21.375 20.125V15.6975C21.3752 15.4356 21.2895 15.1809 21.1311 14.9724C20.9726 14.7639 20.7501 14.6131 20.4978 14.5432C20.2454 14.4733 19.977 14.4881 19.7339 14.5854C19.4907 14.6827 19.2862 14.857 19.1517 15.0817L17.9892 17.0183C17.8781 17.2034 17.721 17.3565 17.5332 17.4628C17.3454 17.5691 17.1333 17.625 16.9175 17.625H11.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgInjuryLegsling.displayName = 'SvgInjuryLegsling';
export default SvgInjuryLegsling;
